import { createReducer, on } from '@ngrx/store';
import {
  loadPartnerCodes,
  loadPartnerCodesFailure,
  loadPartnerCodesSuccess,
  togglePartnerCodesLoading,
} from './partner-codes.actions';
import { IPartnerCodesState, initialUIState } from './partner-codes.state';

export const partnerCodesReducer = createReducer(
  initialUIState,
  on(loadPartnerCodes, (state): IPartnerCodesState => ({ ...state, loading: true })),
  on(loadPartnerCodesSuccess, (state, { partnerCodes }): IPartnerCodesState => ({
    ...state,
    list: partnerCodes,
    loading: false,
  })),
  on(loadPartnerCodesFailure, (state): IPartnerCodesState => ({ ...state, loading: false })),
  on(togglePartnerCodesLoading, (state, { loading }): IPartnerCodesState => ({ ...state, loading }))
);